export default class FilterItemManager {
  constructor (props) {
    this.props = props;
    this.valueList = _.cloneDeep(props.ValueList);
  }

  // 删除字段
  deleteItem (index) {
    this.valueList.splice(index, 1)
    // 更新save内容及排序，用于最后保存提交
    this.valueList.forEach((item, i) => {
      item.orderId = i;
    })
    this.props.setValueList(this.valueList);
  }

  // onchange搜索方式
  autoFlt (index, bAutoflt) {
    this.valueList[index] = { ...this.valueList[index], bAutoflt };
    this.props.setValueList(this.valueList);
  }

  // 是否必填
  required (index, value) {
    this.valueList[index] = { ...this.valueList[index], required: value };
    this.props.setValueList(this.valueList);
  }

  // 是否允许修改
  disabled (index, value) {
    this.valueList[index] = { ...this.valueList[index], disabled: !value };
    this.props.setValueList([...this.valueList])
  }

  setValueList (value) {
    this.valueList = value;
  }

  getValueList () {
    return this.valueList;
  }

  // 拖拽
  dragOrder = (evl, rightFilterModal) => {
    evl.forEach((item, i) => {
      item.orderId = i;
    })
    this.props.setValueList(evl)
  }

  // 运算逻辑变化
  handleChangeLogic (value, storeField) {
    for (const i in this.valueList) {
      if (this.valueList[i].storeField === storeField) {
        if (this.valueList[i].compareLogic != value) {
          this.valueList[i].compareLogic = value;
        }
      }
    }
    this.props.setValueList(this.valueList)
  }
}